import { render, staticRenderFns } from "./Retencao.vue?vue&type=template&id=20da67e7&scoped=true"
import script from "./Retencao.vue?vue&type=script&lang=js"
export * from "./Retencao.vue?vue&type=script&lang=js"
import style0 from "./Retencao.vue?vue&type=style&index=0&id=20da67e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da67e7",
  null
  
)

export default component.exports